/**
 * The tier ladder, as the referrals page reads it. The accrual itself lives on the
 * `ArenaReferral` entity in the api: it is the referral that decides what it pays, and
 * nothing outside the api needed the maths.
 */
import { type ArenaReferralTier } from "@cede/types";
import Decimal from "decimal.js";

/**
 * Index of the tier a combined referee volume sits in. Tiers are ascending open-ended
 * thresholds starting at 0, so the match is the LAST tier whose threshold is reached.
 */
export function resolveArenaReferralTierIndex(volumeUsdt: Decimal.Value, tiers: ArenaReferralTier[]): number {
  const volume = new Decimal(volumeUsdt);
  let index = -1;
  for (const [candidate, tier] of tiers.entries()) {
    if (volume.lt(tier.fromUsdt)) break;
    index = candidate;
  }
  return index;
}
